export default function ToastIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="23"
      version="1"
      viewBox="0 0 442 403"
    >
      <path fill={'#E54A27FF'}
        d="M2120 4020c-301-29-569-113-814-253-439-251-755-637-911-1112-206-623-94-1299 303-1828 313-418 797-701 1323-772 224-31 574-10 774 45 360 100 658 274 913 531 374 377 572 862 572 1399 0 495-161 930-484 1307-310 361-727 590-1215 668-118 18-350 26-461 15zm425-710c338-55 641-202 780-378 61-76 92-142 111-232 24-117 5-198-61-259-41-38-43-41-25-51 25-13 68-87 86-146 25-83 35-255 35-574 0-587-27-673-223-711-81-16-363-6-553 20-245 34-390 42-533 31-137-11-434-51-572-77-47-8-128-16-180-16-114 0-166 19-222 81-77 85-109 188-134 425-41 402 16 770 155 988l48 75-47 51c-66 72-90 127-90 211 0 79 25 138 91 215 129 150 454 298 764 347 159 26 415 26 570 0z"
        transform="matrix(.1 0 0 -.1 0 403)"
      ></path>
      <path fill={'#E54A27FF'}
        d="M1995 3025c-255-40-484-155-545-274-46-91-38-154 31-226 49-52 49-52 29-70-68-62-142-272-171-481-52-396 0-637 156-722 46-25 151-20 290 16 194 50 281 63 440 69 133 4 174 1 360-26 371-54 473-52 549 11 49 40 61 70 80 198 23 165 29 314 17 465-20 240-58 358-141 427l-37 31 33 30c44 38 61 91 44 143-64 201-345 369-690 414-103 13-348 11-445-5z"
        transform="matrix(.1 0 0 -.1 0 403)"
      ></path>
    </svg>
  );
}
